import i18next from "i18next";
import {initReactI18next, useTranslation} from 'react-i18next';

import EN_localization from "./localization/EN_localization.json"
import FR_localization from "./localization/FR_localization.json"
import ES_localization from "./localization/ES_localization.json"

const resources = {
    EN: {
        translation: EN_localization
    },
    FR: {
        translation: FR_localization
    },
    ES: {
        translation: ES_localization
    }
};
let REACT_APP_LANGUAGE = "FR"
if ((window.location.href.indexOf("/en/") > -1) || (window.location.href.indexOf("compare.") > -1)) {
    REACT_APP_LANGUAGE = "EN"
} else if ((window.location.href.indexOf("/es/") > -1) || (window.location.href.indexOf("comparar.") > -1)) {
    REACT_APP_LANGUAGE = "ES"
}

// console.log('environment language detected: ' + REACT_APP_LANGUAGE);

i18next
    .use(initReactI18next)
    .init({
        resources,
        lng: REACT_APP_LANGUAGE,
        keySeparator:false,
        interpolation: {
            escapeValue: false
        }
    }

)

export default i18next;
